import {
    ListContextProvider,
    ResourceContextProvider,
    useGetList,
    useList,
} from 'react-admin';
import { Link, Stack, Typography } from '@mui/material';

import { TasksIterator } from '../tasks/list/TasksIterator';

export const TasksListFilter = ({
    title,
    filter,
    openEditDrawer,
}: {
    title: string;
    filter: any;
    openEditDrawer?: (id: string | number) => void;
}) => {
    const {
        data: tasks,
        total,
        isPending,
    } = useGetList('task', {
        pagination: { page: 0, perPage: 100 },
        sort: { field: 'dueDate', order: 'ASC' },
        filter,
    });

    const listContext = useList({
        data: tasks,
        isPending,
        resource: 'task',
        perPage: 5,
    });

    if (isPending || !tasks || !total) return null;

    return (
        <Stack>
            <Typography variant="overline">{title}</Typography>
            <ResourceContextProvider value="task">
                <ListContextProvider value={listContext}>
                    <TasksIterator
                        sx={{ pt: 0, pb: 0 }}
                        openEditDrawer={openEditDrawer}
                    />
                </ListContextProvider>
            </ResourceContextProvider>
            {total > listContext.perPage && (
                <Stack justifyContent="flex-end" direction="row">
                    <Link
                        href="#"
                        onClick={e => {
                            listContext.setPerPage(listContext.perPage + 10);
                            e.preventDefault();
                        }}
                        variant="body2"
                    >
                        Load more
                    </Link>
                </Stack>
            )}
        </Stack>
    );
};
